import { integrationNames } from '@ardoq/integrations/integration-sources';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { IntegrationInitialState } from 'integrations/common/initialStateTypes';
import { buildInitialTermsState } from 'integrations/common/streams/integrationTermsDictionary/initialState';

export const initialState: IntegrationInitialState = {
  activeIntegration: {
    integrationId: 'it-pedia',
    integrationMappingParams: {
      mapColumnsBy: 'sourceFieldName',
      mapTablesBy: 'id',
    },
  },
  termsDictionary: buildInitialTermsState({
    name: integrationNames.itpedia,
    integrationOverviewTitle: 'IT-Pedia integration',
    rightSidebarHeader: 'Having trouble with the IT-Pedia integration?',
    rightSideBarFAQ: [
      {
        link: KnowledgeBaseLink.IT_PEDIA_INTEGRATION,
        text: 'Onboarding guide.',
      },
    ],
    connectYourAccountTitle:
      'Connect your IT Pedia account to Ardoq to get started.',
    connectYourAccountBtn: 'Connect to IT-Pedia account',
    overviewPrimaryButton: 'Create new sync',
  }),
};
